import ThemedButton from '@getaccept/lib-shared-new/src/components/ThemedButton.vue';
import { useI18n } from 'vue-i18n';
import { UrlHelper } from '@getaccept/lib-shared-new/src/helpers/url.helper';
import { defineComponent, ref, computed, onMounted, onBeforeUnmount } from 'vue';
import BrokenImage from './BrokenImage.vue';
export default defineComponent({
    components: {
        ThemedButton,
        BrokenImage,
    },
    props: {
        contentLinkBlock: {
            type: Object,
            default: () => ({}),
        },
        theme: {
            type: Object,
            default: null,
        },
        documentEdit: {
            type: Boolean,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const imageBroken = ref(false);
        const imageLoaded = ref(false);
        const tooltipOpen = ref(false);
        const hasImage = computed(() => !!imageUrl.value);
        const buttonText = computed(() => { var _a; return ((_a = props.contentLinkBlock) === null || _a === void 0 ? void 0 : _a.buttonText) || t('open-link'); });
        const title = computed(() => { var _a; return ((_a = props.contentLinkBlock) === null || _a === void 0 ? void 0 : _a.title) || ''; });
        const url = computed(() => { var _a; return ((_a = props.contentLinkBlock) === null || _a === void 0 ? void 0 : _a.url) || ''; });
        const description = computed(() => { var _a; return ((_a = props.contentLinkBlock) === null || _a === void 0 ? void 0 : _a.description) || ''; });
        const imageUrl = computed(() => { var _a; return ((_a = props.contentLinkBlock) === null || _a === void 0 ? void 0 : _a.thumbUrl) || ''; });
        const handleClick = () => {
            if (props.documentEdit) {
                showTooltip();
            }
            else {
                openUrl(url.value);
            }
        };
        const handleKeydown = event => {
            if (event.key === 'Escape') {
                closeTooltip();
            }
        };
        const showTooltip = () => {
            tooltipOpen.value = true;
        };
        const closeTooltip = () => {
            tooltipOpen.value = false;
        };
        const openUrl = (contentLinkUrl) => {
            const url = UrlHelper.getHttpsUrl(contentLinkUrl);
            window.open(url, '_blank');
            emit('click', props.contentLinkBlock.id);
            closeTooltip();
        };
        const handleLoadImageError = () => {
            imageBroken.value = true;
        };
        const handleLoaded = () => {
            imageLoaded.value = true;
        };
        onMounted(() => {
            if (props.documentEdit) {
                document.addEventListener('keydown', handleKeydown);
            }
        });
        onBeforeUnmount(() => {
            document.removeEventListener('keydown', handleKeydown);
        });
        return {
            imageBroken,
            imageLoaded,
            tooltipOpen,
            hasImage,
            imageUrl,
            buttonText,
            title,
            url,
            description,
            handleClick,
            closeTooltip,
            handleLoadImageError,
            handleLoaded,
            showTooltip,
            handleKeydown,
            openUrl,
        };
    },
});
